/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { instanceOfFxIdApplicationStoreInAppSteamSteamInAppBillingData, FxIdApplicationStoreInAppSteamSteamInAppBillingDataFromJSONTyped, FxIdApplicationStoreInAppSteamSteamInAppBillingDataToJSON, } from './FxIdApplicationStoreInAppSteamSteamInAppBillingData';
export function FxIdApplicationStoreInAppInAppValidationRequestSteamInAppBillingDataFromJSON(json) {
    return FxIdApplicationStoreInAppInAppValidationRequestSteamInAppBillingDataFromJSONTyped(json, false);
}
export function FxIdApplicationStoreInAppInAppValidationRequestSteamInAppBillingDataFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdApplicationStoreInAppSteamSteamInAppBillingData(json)) {
        return FxIdApplicationStoreInAppSteamSteamInAppBillingDataFromJSONTyped(json, true);
    }
    return {};
}
export function FxIdApplicationStoreInAppInAppValidationRequestSteamInAppBillingDataToJSON(json) {
    return FxIdApplicationStoreInAppInAppValidationRequestSteamInAppBillingDataToJSONTyped(json, false);
}
export function FxIdApplicationStoreInAppInAppValidationRequestSteamInAppBillingDataToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    if (instanceOfFxIdApplicationStoreInAppSteamSteamInAppBillingData(value)) {
        return FxIdApplicationStoreInAppSteamSteamInAppBillingDataToJSON(value);
    }
    return {};
}
//# sourceMappingURL=FxIdApplicationStoreInAppInAppValidationRequestSteamInAppBillingData.js.map